import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {slide as Menu} from 'react-burger-menu'
import config from '../../config'
import format from '../../helpers/format'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './FundMenu.css'

@CSSModules(Styles, {allowMultiple:true})
export default class FundMenu extends Component {
  static propTypes = {
    active: PropTypes.string.isRequired,
    fundId: PropTypes.string.isRequired,
    investmentVehicleId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    ticker: PropTypes.string
  }
  constructor(props){
    super(props)
    this.state = {
      menuOpen: false,
    }
  }
  clickMenu = () =>{
    this.setState({menuOpen: !this.state.menuOpen})
  }
  isActive = (title) => {
    return (title === this.props.active)
  }
  render() {
    const ticker = this.props.ticker || 'N'
    const name = format.sanitize(this.props.name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = this.props.fundId+'/'+this.props.investmentVehicleId
    const fossilsUrl = urlStart+'/fossil-fuel-investments/'+urlEnd
    const financeUrl = urlStart+'/fossil-finance-insurance/'+urlEnd
    const cleanUrl = urlStart+'/clean200-investments/'+urlEnd
    const carbonUrl = urlStart+'/carbon-footprint/'+urlEnd
    const profileUrl = urlStart+'/investment-profile/'+urlEnd

    const menuConfig = [
      [fossilsUrl, 'Fossil fuels'],
      [financeUrl, 'Banks & insurers'],
      [cleanUrl, 'Clean200'],
      [profileUrl, 'More'],
      // [carbonUrl, 'Carbon footprint',(
      //   <span styleName='deprecated-option'>
      //     Carbon footprint<LinkIcon faclass='fa-exclamation-triangle'/>
      //   </span>
      // )],
    ]

    return (
      <ContainerDivs>
        <div styleName='menu-links'>
          {
            menuConfig.map((e, i) => {
              const url = e[0]
              const label = e[1]
              return (
                <div
                  styleName={
                    this.isActive(label) ?
                      'menu-link-active' :
                      'menu-link'
                  }
                  key={'menu-' + i}
                >
                  <Link to={url} title={label}>
                    <div styleName='menu-link-flex'>
                      <div styleName='menu-link-label'>
                        {e[2] || label}
                      </div>
                    </div>
                  </Link>
                </div>
              )
            })
          }
        </div>
      </ContainerDivs>
    )
  }
}

